<template>
  <div class="banner-container">
    <div class="banner-content">
      <div :class="$vuetify.breakpoint.mdAndUp ? 'banner-badge mb-6' : 'banner-badge mb-4'">
        수출바우처 참여기업 전용
      </div>
      <div class="banner-title">독보적인 글로벌 인플루언서 마케팅 <br />수행기업 마야크루와 함께</div>
      <div :class="$vuetify.breakpoint.mdAndUp ? 'banner-bold-title mb-12' : 'banner-bold-title mb-6'">
        성공적인 글로벌 진출을
        <div class="mobile"></div>
        만들어보세요.
      </div>
      <div class="banner-button" @click="handleClickBannerButton">지금 바로 상담받기</div>
    </div>

    <div>
      <img
        v-if="$vuetify.breakpoint.mdAndUp"
        class="banner-image"
        width="390"
        height="350"
        src="@/assets/img/campaign/export-voucher/banner-desktop.png"
        alt="banner-image" />
      <img
        v-else
        class="banner-image"
        width="100%"
        src="@/assets/img/campaign/export-voucher/banner-mobile.png"
        alt="banner-image" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClickBannerButton() {
      window.scrollTo(0, document.body.scrollHeight);
      window.dataLayer.push({
        event: 'clickButton',
        page: 'exportVoucher',
        objectSection: 'main',
        objectType: 'button',
        objectId: 'openLeadForm',
        objectName: '지금 바로 상담받기',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.banner-container {
  display: flex;
  gap: 80px;
  padding: 120px 0px 100px 0px;
  align-items: center;
  justify-content: center;
  max-width: 1072px;
  width: 100%;

  @media (max-width: 960px) {
    text-align: center;
    flex-direction: column;
    gap: 32px;
    padding: 36px 16px 40px 16px;
  }
}

.banner-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  @media (max-width: 960px) {
    align-items: center;
    text-align: center;
  }
}

.banner-badge {
  display: flex;
  padding: 4px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 28px; /* 200% */

  @media (max-width: 960px) {
    font-size: 12px;
    line-height: 20px; /* 166.667% */
  }
}

.banner-title {
  color: #fff;
  font-family: Pretendard;
  font-size: 32px;
  font-style: normal;
  font-weight: 300;
  line-height: 52px; /* 162.5% */

  @media (max-width: 960px) {
    font-size: 20px;
    line-height: 28px; /* 140% */
  }
}

.banner-bold-title {
  color: #fff;
  font-family: Pretendard;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 52px; /* 130% */

  @media (max-width: 960px) {
    font-size: 24px;
    line-height: 30px; /* 125% */
  }
}

.banner-image {
  border-radius: 16px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(2px);
}

.banner-button {
  border-radius: 16px;
  background: #f53c4b;

  box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  height: 60px;
  padding: 16px 24px;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;

  color: #fff;
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
}
</style>
